
const personalCenter = {
    props: {
        statisticsInfo: {
            type: Object,
            default: () => {}
        },
        isSelf: {
            type: Boolean,
            default: true
        },
        isLogin: {
            type: Boolean,
            default: false
        },
        userId: {
            type: [String, Number]
        },
        sexual: {
            type: [String, Boolean, Number]
        }
    },
    filters: {
        transformUnit (val) {
            if (val > 10000) {
                let num = Math.floor(val / 1000);
                const remainder = val % 1000;
                if (remainder > 100) {
                    num += `.${Math.floor(remainder / 100)}`;
                }
                return `${num}K`;
            }
            return val;
        }
    },
    data () {
        return {
            tabName: '',
            loading: true,
            isLoading: false,
            curPage: 1,
            isTimer: null,
            totalPage: null,
            isPageOver: false,
            isThrottled: false,
            isMoreLoading: false
        };
    },
    watch: {
        isLogin: {
            handler (val) {
                if (val && this.getTabName) {
                    this.getTabName(this.tabName);
                }
            }
        },
        userId: {
            handler (val) {
                if (val) {
                    const { tabName } = this.$route.query;
                    this.tabName = tabName || this.tabName;
                    window.scrollTo(0, 0);
                    if (this.getTabName) {
                        this.getTabName(this.tabName);
                    }
                } else {
                    this.loading = false;
                }
            },
            immediate: true
        }
    },
    created () {
        window.addEventListener('beforeunload', this.setScrollTop);
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy () {
        clearTimeout(this.isTimer);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('beforeunload', this.setScrollTop);
    },
    methods: {
        // 页面手动刷新滚动到顶部
        setScrollTop () {
            window.scrollTo(0, 0);
        },
        // 滚动加载
        scrollLoading (fn, isTabName = true) {
            // 滚动加载
            if (!this.isPageOver && !this.isThrottled && !this.isMoreLoading) {
                this.isThrottled = true;
                this.isTimer = setTimeout(() => {
                    this.isThrottled = false;
                    const scrollHeight = document.documentElement.scrollHeight;
                    const innerHeight = window.innerHeight;
                    const scrollY = window.scrollY;
                    const height = 80 + 320; // 320 footer的高度
                    if (scrollHeight - innerHeight - scrollY < height) {
                        this.curPage++;
                        clearTimeout(this.isTimer);
                        if (isTabName) {
                            fn(this.tabName, true);
                        } else {
                            fn(true);
                        }
                    }
                }, 200);
            }
        }
    }
};

export default personalCenter;



// WEBPACK FOOTER //
// ./src/mixins/personalCenter.js